import * as EmailValidator from 'email-validator';
import { isWebUri } from 'valid-url';


export function validateEmail(email: string)
{
  return(
    !(/[^0-9.a-z0-F_-]/gi).test(email) &&
    email.length <= 63 &&
    EmailValidator.validate(email));
}

export function validateSalesTax(value: string)
{
  return Number(value) < 100 && Number(value) >= 0;
}

export function validateVendorTaxPercent(value: string)
{
  return Number(value) < 100 && Number(value) > -100;
}

export function validateVendorBaseTax(value: string)
{
  return Number(value) < 10000 && Number(value) > -10000;
}

export function validateUsername(username: string)
{
  return (
    !(/[^0-9.a-z0-F_-]/gi).test(username) &&
    username.length <= 31);
}

export function validatePassword(password: string)
{
  return(
    !(/[^0-9a-z0-F)([\]+"':;/#*,_.&°!£-]/gi).test(password) &&
    password.length <= 32);
}

export function validateDosesPerDay(value: string | number)
{
  return Number(value) >= 0 && Number(value) <= 255;
}

export function validateDaysPerMonth(value: string | number)
{
  return Number(value) >= 0 && Number(value) <= 255;
}

export function validateDose(value?: string | number)
{
  return value !== undefined && Number(value) >= 0 && Number(value) < 9999999;
}

export function validatePrice(value: string)
{
  return Number(value) <= 999999 && Number(value) >= 0;
}

export function validateFundraiserTitle(value: string)
{
  return value.length <= 127;
}

export function validateFundraiserRecipient(value: string)
{
  return value.length <= 31;
}

export function validateUrl(value: string)
{
  return (value.length <= 511) && isWebUri(value);
}

export function validateComment(value: string)
{
  return value.length <= 200;
}

export function validateProductAmount(value: string)
{
  return Number(value) <= 9999.99 && Number(value) > 0;
}

export function validateProtocolOrFolderName(value: string)
{
  return value.length <= 63
}

export function validateQuantity(value: string)
{
  return Number(value) <= 255 && Number(value) > 0 && Number(value) % 1 === 0;
}

